/**
 * @file Swimlane/constants.js
 * @copyright 2017 CBC/Radio-Canada. All rights reserved.
 * @author Fitore Jaha [fitore.jaha@cbc.ca]
 */

export const NUM_SWIMLANE_STORIES = 8;

//Props for Federal Election 2019 Top storties swimlane
export const CANADA_VOTES_PROPS = {
    section: "news/elections/topstories",
    className: "fedElectionSwimlane",
    headline: "Canada Votes",
    itemCount: 4,
    showMoreLink: false,
    customHeadlineLink: "",
    hasHeadlineLink: false,
};

//Props for Federal Election 2019 Election Toolkit swimlane
export const ELECTION_TOOLKIT_PROPS = {
    section: "news/elections/utilities",
    className: "fedElectionSwimlane",
    headline: "Election Toolkit",
    itemCount: 4,
    showMoreLink: false,
    contentListClasses: "hideContentBottom",
    hasHeadlineLink: false,
};
